import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@anduin/auth';
import { Globals } from '@anduin/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 200) {
          if (error.status === 401 || error.status === 403) {
            // TODO - handle auto logout
            // // A call to a REST service generated a "not authenticated" or "not authorized" error
            // if (this.globals.ssoEnabled) {
            //   // navigate the user to the SSO login page so that they can authenticate
            //   window.location.replace(this.globals.serverAddress + '/' + this.globals.serverPath + '/saml/login');
            // }
          } else if (error.status === 500) {
            // LogRocket only notifies us the first time an error is received. Create a unique error message so that we are notified 1 time per user/guest.
            console.error(`HttpErrorInterceptor caught an error: ${error.message} ${this.authService.getStaffId()}`);
          } else {
            this.spinner.hide();
            console.error('An error occurred:', error.error.message);
            // TODO: Have a generic "something blew up" page?
          }
        }
        return throwError(error);
      }),
    );
  }
}
